import { render, staticRenderFns } from "./renja_permendagri.vue?vue&type=template&id=6634828d&"
import script from "./renja_permendagri.vue?vue&type=script&lang=js&"
export * from "./renja_permendagri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports